import styled from 'styled-components';

import { media } from 'styles/utils';

export const ContentBlockWithStatisticsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;

  ${media.tablet`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 48px;
  `}

  ${media.desktop`
    grid-gap: 72px;
  `}
`;
